import { combineEpics } from 'redux-observable';
import { fetchAllMealSlots } from '@/store/epics/staff/warehouses/meal-slots/fetch-all-meal-slots.epic';
import { createMealSlotEpic } from '@/store/epics/staff/warehouses/meal-slots/create-meal-slot.epic';
import { removeMealSlotEpic } from './remove-meal-slot.epic';

export const combinedMealSlotsEpics = combineEpics(fetchAllMealSlots, createMealSlotEpic, removeMealSlotEpic);
